import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import white_drop_icon from '../assets/images/whitedrop_down.svg';
import verified from '../assets/images/verified.svg';
import default_user from '../assets/images/default_user.webp';
import config from '../config/config'; 

const CollectionCreateList = ({ user, userId }) => {
  const { user_id } = useParams();
  const [isRestricted, setIsRestricted] = useState(false);
  const [profiles, setProfiles] = useState([]);
  const [showOnlyFree, setShowOnlyFree] = useState(false);
  const [restrictedUsers, setRestrictedUsers] = useState(new Set());
  const [blockedUsers, setBlockedUsers] = useState(new Set());
  const [toastMessage, setToastMessage] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [receiverDetails, setReceiverDetails] = useState({});
  const [toastType, setToastType] = useState('');
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [showModal, setShowModal] = useState(false); 
  const [sortedUsersalldelete, setSortedUsersallDelete] = useState([]);
  const [reportReason, setReportReason] = useState('');
  const [selectedReportReason, setSelectedReportReason] = useState('');
  const [showSaveToListModal, setShowSaveToListModal] = useState({ visible: false, userId: null });
  const [showCreateListModal, setShowCreateListModal] = useState(false);
  const [listName, setListName] = useState('');
  const [wordCount, setWordCount] = useState(0);
  const [userLists, setUserLists] = useState([]); 
  const [apiResponseMessage, setApiResponseMessage] = useState('');
  const navigate = useNavigate();
  const [checkedLists, setCheckedLists] = useState(new Set());
  const { username } = useParams();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
    }
  }, [navigate]);

  const fetchUserLists = async () => {
    try {
      const token = localStorage.getItem('token');
      const url = `${config.baseURL}/get-users-list`;

      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // Ensure Content-Type is set if necessary
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success) {
        setUserLists(data.data);
        // Initialize checkedLists state based on user list data
        const initialCheckedLists = new Set(data.data
          .filter(list => list.users.some(user => user.id === showSaveToListModal.userId))
          .map(list => list.id)
        );
        setCheckedLists(initialCheckedLists);
      } else {
        console.warn('Failed to fetch user lists:', data.message); // Add more detailed logging if needed
        setUserLists([]);
      }
    } catch (error) {
      console.error('Error fetching user lists:', error);
      setUserLists([]);
    }
  };

  useEffect(() => {
    if (showSaveToListModal) {
      fetchUserLists();
    }
  }, [showSaveToListModal]);


// Handle the checkbox change (add/remove user from list)
const handleCheckboxChange = async (listId, userId, isChecked) => {
  // Set the URL based on whether we're adding or removing a user
  const url = `${config.baseURL}/${isChecked ? 'add-user-to-list' : 'remove-user-from-list'}`;
  const params = new URLSearchParams();
  // Determine the parameters based on whether adding or removing
  if (isChecked) {
    // For adding a user
    params.append('user_list_id', listId);
    params.append('listed_user_id', userId);
  } else {
    // For removing a user
    params.append('user_id', userId); // Correct parameter for user ID
    params.append('list_id', listId); // Correct parameter for list ID
  }

  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(url, params, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/x-www-form-urlencoded' // Ensure correct Content-Type
      }
    });

    // Update the checkedLists state based on whether we're adding or removing
    setCheckedLists(prevCheckedLists => {
      const updatedCheckedLists = new Set(prevCheckedLists);
      if (isChecked) {
        updatedCheckedLists.add(listId); // Add list ID when checked
      } else {
        updatedCheckedLists.delete(listId); // Remove list ID when unchecked
      }
      return updatedCheckedLists;
    });

  } catch (error) {
    console.error('Error updating user list:', error);
    console.error('Error response:', error.response?.data || error.message);
  }
};


const handleShowSaveToListModal = (userId) => {
  console.log('Show Save to List Modal for userId:', userId);
  document.body.classList.add('modal-open-message_lightbox_gallery');
  setShowSaveToListModal({ visible: true, userId });
};

const handleModalSubmit = async (e) => {
  e.preventDefault();
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${config.baseURL}/report-user`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        report_to: reportReason,
        reason: selectedReportReason,
      }),
    });

    const data = await response.json();
    
    if (data.success) {
      // Show success toast and hide it after 2 seconds
      setToastMessage(data.message);
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
        setToastMessage(''); // Clear message
      }, 2000); // 2 seconds delay
      setErrorMessage(''); // Clear any previous error message
    } else {
      // Show error message and hide it after 2 seconds
      setErrorMessage(data.message);
      setTimeout(() => {
        setErrorMessage(''); // Clear error message
      }, 2000); // 2 seconds delay
    }
  } catch (error) {
    // Show error message for fetch failure and hide it after 2 seconds
    setErrorMessage('Error reporting user');
    setTimeout(() => {
      setErrorMessage(''); // Clear error message
    }, 2000); // 2 seconds delay
  } finally {
    // Hide the modal in all cases
    setShowModal(false);
  }
};


  const handleSaveToListClick = () => {
    setShowSaveToListModal(true);
  };

  const handleCreateListClick = () => {
    setShowSaveToListModal(false);
    setShowCreateListModal(true);
  };

  const handleCloseModal = () => {
    document.body.classList.remove('modal-open-message_lightbox_gallery');
    setShowModal(false);
  };

  const reportReasons = [
    'Violates OnlyFans Terms of Service',
    'Contains copyrighted material (DMCA)',
    'Child Sexual Abuse Material (CSAM)',
    'Report Spam',
    'Report Abuse'
  ];

  useEffect(() => {
    // Initialize the checked state based on userLists if needed
  }, [userLists]);


const handleCreateListSubmit = async (e) => {
  e.preventDefault();
  try {
    // Validate list name
    if (listName.trim() === '') {
      setErrorMessage('List name cannot be empty');
      setTimeout(() => setErrorMessage(''), 2000); // Clear error message after 2 seconds
      return;
    }
    if (listName.length > 64) {
      setErrorMessage('List name cannot exceed 64 characters');
      setTimeout(() => setErrorMessage(''), 2000); // Clear error message after 2 seconds
      return;
    }

    const token = localStorage.getItem('token');
    const response = await fetch(`${config.baseURL}/create-user-list`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams({ title: listName }) // Use 'title' instead of 'list_name'
    });

    const data = await response.json();
    
    // If success
    if (data.success) {
      setToastMessage(data.message);
      setTimeout(() => setToastMessage(''), 2000); // Clear success message after 2 seconds
      setShowCreateListModal(false); // Close modal
      setListName(''); // Clear list name input
      setWordCount(0); // Reset word count
    } else {
      // If error from server response
      setErrorMessage(data.message);
      setTimeout(() => setErrorMessage(''), 2000); // Clear error message after 2 seconds
    }
  } catch (error) {
    setErrorMessage('Error creating list');
    setTimeout(() => setErrorMessage(''), 2000); // Clear error message after 2 seconds
  }
};



  return (
    <div>


      {toastMessage && (
        <div className={`toast-message ${toastType}`}>
          {toastMessage}
        </div>
      )}

      <div className="card_favorite_box">
        <Link onClick={() => handleShowSaveToListModal(user.user_id)}>
          <div className="svg_favourite_icon">
            <svg
              width={54}
              height={54}
              viewBox="0 0 54 54"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_81_76)">
                <path
                  d="M25.3255 7.05717C25.8633 5.96764 26.1322 5.42288 26.4973 5.24883C26.8149 5.0974 27.1839 5.0974 27.5015 5.24883C27.8665 5.42288 28.1354 5.96764 28.6732 7.05717L33.7755 17.3938C33.9343 17.7154 34.0136 17.8762 34.1297 18.0011C34.2324 18.1117 34.3556 18.2012 34.4924 18.2649C34.647 18.3368 34.8244 18.3627 35.1794 18.4146L46.5923 20.0827C47.7942 20.2584 48.3951 20.3462 48.6732 20.6398C48.9151 20.8952 49.0289 21.2461 48.9829 21.5949C48.9299 21.9958 48.4949 22.4195 47.6248 23.267L39.3694 31.3077C39.1121 31.5584 38.9834 31.6837 38.9003 31.8328C38.8268 31.9649 38.7797 32.1099 38.7615 32.2599C38.7409 32.4294 38.7713 32.6064 38.832 32.9605L40.7799 44.3177C40.9854 45.5156 41.0881 46.1145 40.895 46.4699C40.7271 46.7792 40.4285 46.9961 40.0825 47.0602C39.6848 47.1339 39.147 46.8511 38.0713 46.2854L27.8682 40.9197C27.5503 40.7525 27.3914 40.6689 27.2239 40.6361C27.0756 40.607 26.9231 40.607 26.7749 40.6361C26.6074 40.6689 26.4485 40.7525 26.1305 40.9197L15.9275 46.2854C14.8518 46.8511 14.314 47.1339 13.9163 47.0602C13.5703 46.9961 13.2717 46.7792 13.1037 46.4699C12.9107 46.1145 13.0134 45.5156 13.2189 44.3177L15.1668 32.9605C15.2275 32.6064 15.2578 32.4294 15.2373 32.2599C15.2191 32.1099 15.1719 31.9649 15.0984 31.8328C15.0154 31.6837 14.8867 31.5584 14.6294 31.3077L6.37399 23.267C5.5039 22.4195 5.06885 21.9958 5.01591 21.5949C4.96985 21.2461 5.08364 20.8952 5.3256 20.6398C5.6037 20.3462 6.20462 20.2584 7.40645 20.0827L18.8194 18.4146C19.1743 18.3627 19.3518 18.3368 19.5064 18.2649C19.6432 18.2012 19.7664 18.1117 19.8691 18.0011C19.9851 17.8762 20.0645 17.7154 20.2233 17.3938L25.3255 7.05717Z"
                  stroke="#00AFF0"
                  strokeWidth={5}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_81_76">
                  <rect width={54} height={54} fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          Add to favorites and other lists{" "}
        </Link>
      </div>


      
        <div className="share_text">
             {errorMessage && <div className="error_message">{errorMessage}</div>}
             {showToast && <div className="toast_message">{toastMessage}</div>}
        </div>

      {/* Save to List Modal */}
      {showSaveToListModal.visible && (
          <>
            <div className="modal-overlay-dark" onClick={() => setShowSaveToListModal({ visible: false, userId: null })}></div>
            <div className="modal restoreAccessModalAccess save_list_popup fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="saveToListModalLabel" aria-hidden="true">
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="saveToListModalLabel">SAVE TO LIST</h5>
                  </div>
                  <div className="modal-body">
                     {userLists.length === 0 ? (
        <div className="no_list_message">Nothing found</div>
      ) : (
        <ul>
          {userLists.map(list => (
            <li key={list.id}>
              <div className="list_wrap_popup">
                <div className="m-checkbox-row checkbox_table">
                  <input
                    type="checkbox"
                    checked={checkedLists.has(list.id)}
                    onChange={(e) => {
                      const userId = showSaveToListModal.userId;
                      console.log(`Checkbox changed for listId: ${list.id}, userId: ${userId}`);
                      handleCheckboxChange(list.id, userId, e.target.checked);
                    }}
                    name=""
                    id={`checkbox-${list.id}`}
                  />
                  <label htmlFor={`checkbox-${list.id}`} className="g-input__wrapper"></label>
                </div>
                <div className="list_popup">
                  <div className="list_popup_left">
                    <span>{list.title}</span>
                    <small>{list.user_count} user</small>
                  </div>
                  <div className="list_popup_right">
                    {list.users && list.users.length > 0 ? (
                      list.users.map(user => (
                        user.profile_image && (
                          <img
                            key={user.id}
                            src={user.profile_image}
                            alt={user.title}
                            style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                          />
                        )
                      ))
                    ) : (
                      list.profile_image && (
                        <img
                          src={list.profile_image}
                          alt={list.title}
                          style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                        />
                      )
                    )}
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-primary cancel_btn" onClick={handleCreateListClick}>
                      <svg
                        enableBackground="new 0 0 50 50"
                        height="20px"
                        id="Layer_1"
                        version="1.1"
                        viewBox="0 0 50 50"
                        width="20px"
                        xmlSpace="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                      >
                        <rect fill="none" height={20} width={20} />
                        <line
                          fill="none"
                          stroke="#00aff0"
                          strokeMiterlimit={10}
                          strokeWidth={4}
                          x1={9}
                          x2={41}
                          y1={25}
                          y2={25}
                        />
                        <line
                          fill="none"
                          stroke="#00aff0"
                          strokeMiterlimit={10}
                          strokeWidth={4}
                          x1={25}
                          x2={25}
                          y1={9}
                          y2={41}
                        />
                      </svg>
                      New list
                    </button>
                    <button type="button" className="btn btn-secondary cancel_btn" onClick={() => setShowSaveToListModal({ visible: false, userId: null })}>Close</button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      {/* Create New List Modal */}
      {showCreateListModal && (
        <>
          <div className="modal-overlay-dark" onClick={() => setShowCreateListModal(false)}></div>
          <div id="restoreAccessForm" className="modal restoreAccessModalAccess fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="createListModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="createListModalLabel">CREATE NEW LIST</h5>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleCreateListSubmit}>
                    <div className="position_relative">
                      <input
                        type="text"
                        className="form-control"
                        value={listName}
                        onChange={(e) => {
                          setListName(e.target.value);
                          setWordCount(e.target.value.length);
                        }}
                        maxLength="64"
                        placeholder=""
                      />
                      <label htmlFor="listname" className="placeholder-label">List Name</label>
                      <div className="word_count">{wordCount} / 64</div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-primary send_btn" onClick={() => setShowCreateListModal(false)}>Cancel</button>
                      <button type="submit" className="btn btn-primary send_btn">Save</button>
                    </div>
                  </form>
                  {apiResponseMessage && <p>{apiResponseMessage}</p>}
                </div>
              </div>
            </div>
          </div>
        </>
      )}


      {/* Toast for user feedback */}
      {showToast && (
        <div className="toast">
          <p>{toastMessage}</p>
        </div>
      )}
      {errorMessage && (
        <div className="error">
          <p>{errorMessage}</p>
        </div>
      )}       

    </div>
  );
};

export default CollectionCreateList;


